"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const PayeeFieldEditable_1 = __importDefault(require("./PayeeFieldEditable"));
const PayeeField = (props) => {
    const [payeeFieldState, setPayeeFieldState] = (0, react_1.useState)({
        value: props.value,
    });
    const prevPayee = (0, react_use_1.usePrevious)(props.value.payee);
    (0, react_1.useEffect)(() => {
        if (props.value.payee !== prevPayee) {
            setPayeeFieldState((prevState) => (Object.assign(Object.assign({}, prevState), { value: props.value })));
        }
    }, [props.value, prevPayee]);
    return (<>
      {props.editable && <PayeeFieldEditable_1.default {...props}/>}
      {!props.editable &&
            <QTip_1.default wrapOnly title={props.tooltip ? payeeFieldState.value.payee : null}>
          <QTypography_1.default variant="body2" clickable={props.clickable} thinFont className={props.classNameWhenNotEditable}>
            {payeeFieldState.value.payee}
          </QTypography_1.default>
        </QTip_1.default>}
    </>);
};
exports.default = PayeeField;
